import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import EndorsmentBox from '@components/shared/EndorsmentBox';
import useDesktop from '@components/shared/useDesktop';
import { PageSlice } from '@contracts';

const settings = {
  arrows: false,
  dots: true,
  infinite: false,
  arrow: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

interface Props {
  slice: PageSlice;
}

const ProvioticsTestimonials: React.FC<Props> = ({ slice }) => {
  const isMobile = !useDesktop(1220);
  const backgroundColor = slice?.primary?.background_color ?? Colors.mint;

  return (
    <Container $textColor={slice.primary?.text_color ?? Colors.forestGreen}>
      {isMobile ? (
        <Slider {...settings}>
          {slice.items?.map((testimonial, index) => (
            <SlideInner key={index}>
              <EndorsmentBox data={testimonial} key={index} backgroundColor={backgroundColor} />
            </SlideInner>
          ))}
        </Slider>
      ) : (
        slice.items?.map((testimonial, index) => <EndorsmentBox data={testimonial} key={index} backgroundColor={backgroundColor} />)
      )}
    </Container>
  );
};

export default ProvioticsTestimonials;

interface StyleProps {
  $textColor?: string;
}

const Container = styled.div<StyleProps>`
  color: ${(props) => props.$textColor};
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  margin: auto;
  gap: 40px;
  justify-content: center;

  @media only screen and (max-width: 1220px) {
    width: 100vw;
    justify-content: center;

    & .slick-slider {
      display: flex;
      justify-content: center;
      width: 100vw;
      flex-wrap: wrap;
    }
    .slick-dots {
      margin-top: 40px;
      position: relative;
      width: 100vw;
    }
    & .slick-slide.slick-active {
      opacity: 1;
    }

    .slick-slide {
      height: auto;

      & > div {
        height: 100%;
        display: flex;
      }
    }
    .slick-track {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: stretch;
    }
  }
`;

const SlideInner = styled.div`
  justify-content: center;
  text-align: center;
  width: 100vw;

  @media only screen and (max-width: 1220px) {
    flex-direction: column;
    align-items: center;
    display: flex !important;
  }
`;
